import { isPlatformBrowser } from '@angular/common';
import { Component, HostListener, Inject, OnInit, PLATFORM_ID } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';
import { Footer } from 'src/app/shared/content/content';
import { environment } from 'src/environments/environment';
import { FooterContent } from '../../models/footer-content.model';
import { CmsService } from '../../services/cms.service';
import { LocalStorageService } from '../../services/local-storage.service';
import { TagManagerService } from '../../services/tag-manager.service';
import { UserAgentService } from '../../services/user-agent.service';

@Component({
    selector: 'app-footer',
    templateUrl: './footer.component.html',
    styleUrls: ['./footer.component.scss'],
    standalone: false
})
export class FooterComponent implements OnInit {
	isMobile: boolean = false;
	emailToShow: string = '';
	user: any = '';
	isDealer: boolean = false;
	footerData: FooterContent | null | undefined = null;
	environment: any;
	textFooter = Footer;
	mobilizesLogo: boolean = false;

	constructor(
		@Inject(PLATFORM_ID) private platformId: Object,
		private userAgent: UserAgentService,
		private localStorage: LocalStorageService,
		private router: Router,
		private tagManager: TagManagerService,
		private cmsService: CmsService
	) {
		this.router.events.subscribe(event => {
			if (event instanceof NavigationEnd) {
				this.verifyUser();

				this.mobilizesLogo =
					event.url === '/renta-de-carros-mensual/rapido/dados-da-empresa' ||
					event.url === '/renta-de-carros-mensual/rapido/dados-pessoais' ||
					event.url === '/renta-de-carros-mensual/rapido/finalizar' ||
					event.url === '/renta-de-carros-mensual/rapido/sucesso' ||
					event.url === `/area-logada` ||
					event.url === `/area-logada/perfil` ||
					event.url === `/area-logada/pedidos` ||
					event.url === `/area-logada/contratos` ||
					event.url === `/area-logada/dados-de-pagamento` ||
					event.url === `/area-logada/servicos`
						? true
						: false;
			}
		});
		this.isMobile = userAgent.verifyMobile();
		this.user = localStorage.getItem('ROD-logged.user');
		this.environment = environment;
	}

	ngOnInit(): void {
		if (!isPlatformBrowser(this.platformId)) return;

		this.verifyUser();
		this.cmsService.getByPath('pages/704').subscribe(result => {
			this.footerData = result.data.content;
			this.emailToShow = result.data?.content['e-mail_bloco_esquerda'] || '';
		});
	}

	scrollTop() {
		if (isPlatformBrowser(this.platformId)) {
			window.scrollTo({ top: 0, behavior: 'smooth' });
		}
	}

	verifyUser() {
		this.user = this.localStorage.getItem('ROD-logged.user');

		if (this.user !== undefined && this.user !== null && typeof this.user === 'string') {
			this.user = JSON.parse(this.user);
			this.isDealer = !!this.user.authContext.dealershipId;
		} else {
			this.isDealer = false;
		}
	}

	emitEvent(title: string) {
		this.tagManager.setTagManager({
			event: 'gaEvent',
			eventCategory: 'footer',
			eventAction: 'clique',
			eventLabel: title,
		});
	}

	@HostListener('window:resize')
	onResize() {
		this.isMobile = this.userAgent.verifyMobile();
	}
}
